import React, { useEffect, useMemo } from 'react';
import WorkspaceManager from '../managers/WorkspaceManager';
import { IProject } from '../models/IProject';
import { MmgWorkspaceCard } from './card/workspace-card';
import { MmgCardPlaceholders } from './card/workspace-card-placeholders';
import { IWorkspaceScreenshot } from '../models/IWorkspaceData';

interface IMmgWorkspaceProps {
  workspaceId: string;
  projectList: Array<IProject>;
  workspaceScreenshot?: IWorkspaceScreenshot;
}

const MmgWorkspaceOverview: React.FC<IMmgWorkspaceProps> = ({ workspaceId, projectList, workspaceScreenshot }) => {
  const [isFetchingOverview, setIsFetchingOverview] = React.useState(false);
  const [workspace, setWorkspace] = React.useState(null);

  useEffect(
    () => {
      const getWorkspaceOverview = async () => {
        try {
          setIsFetchingOverview(true);
          const overview = await WorkspaceManager.getWorkspaceOverview(workspaceId, true);
          setWorkspace(overview);
        } catch (error) {
          console.warn('Failed to load recent workspace overview.', error);
        } finally {
          setIsFetchingOverview(false);
        }
        setIsFetchingOverview(false);
      };

      if (workspaceId) {
        getWorkspaceOverview();
      }
    },
    [workspaceId],
  );

  const image = useMemo(() => {
    if (workspaceScreenshot && workspaceScreenshot.workspaceId === workspaceId){
      return workspaceScreenshot.image;
    }
  },[workspaceId, workspaceScreenshot])

  return isFetchingOverview ? (
    <MmgCardPlaceholders size={1} excludeWrapper={true} />
  ) : workspace ? (
    <MmgWorkspaceCard
      workspace={workspace}
      key={workspace.id}
      project={projectList.find((p) => p.id === workspace.projectId)}
      image={image}
    />
  ) : null;
};

export default MmgWorkspaceOverview;
